import React from 'react';
import { Card, CardContent } from './ui/card';
import { Users, Layers, ClipboardCheck, Package, UploadCloud, MessageSquare } from 'lucide-react';

const WhyChoose = () => {
  const advantages = [
    {
      icon: Layers,
      title: 'Tous les corps de métier',
      description: "De la rénovation complète à la façade, un seul interlocuteur coordonne l'ensemble de votre projet.",
    },
    {
      icon: Package,
      title: 'Matériaux étudiés',
      description: 'Nous sélectionnons des matériaux adaptés à chaque bâti, y compris des solutions naturelles et biosourcées.',
    },
    {
      icon: ClipboardCheck,
      title: 'Travail dans les règles de l\'art',
      description: 'Mise en œuvre soignée et respect des règles techniques pour un résultat durable.',
    },
    {
      icon: Users,
      title: 'Paris & Île-de-France',
      description: 'Présence locale et bonne connaissance du bâti parisien, ancien comme récent.',
    },
    {
      icon: UploadCloud,
      title: 'Dossiers pros simplifiés',
      description: 'Architectes, syndics et apporteurs d\'affaires peuvent transmettre plans, CCTP et DPGF en ligne.',
    },
    {
      icon: MessageSquare,
      title: 'Suivi transparent',
      description: 'Écoute, conseil et point régulier sur l\'avancement de votre chantier.',
    },
  ];

  return (
    <section className="py-24 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider mb-3 block">
            Nos engagements
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">Pourquoi choisir VIREO ?</h2>
          <p className="text-xl text-slate-600">
            Un partenaire de confiance pour vos projets de rénovation à Paris et en Île-de-France.
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-14">
          {advantages.map((advantage, index) => {
            const IconComponent = advantage.icon;
            return (
              <Card
                key={index}
                data-testid={`why-choose-${index}`}
                className="border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300 bg-white group"
              >
                <CardContent className="pt-8 pb-8">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mb-5 group-hover:bg-gradient-to-br group-hover:from-emerald-600 group-hover:to-cyan-600 transition-all duration-300">
                      <IconComponent className="h-8 w-8 text-emerald-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3">{advantage.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{advantage.description}</p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Identity Card — factual, keep artisan attestation */}
        <div className="max-w-4xl mx-auto">
          <Card data-testid="vireo-identity-card" className="bg-gradient-to-br from-emerald-50 to-cyan-50 border-emerald-200">
            <CardContent className="py-8 px-8">
              <div className="flex flex-col md:flex-row items-center gap-6">
                <img src="/images/logo-artisan.png" alt="Logo Artisan" className="h-20 w-auto flex-shrink-0" />
                <div className="text-center md:text-left md:border-l md:border-emerald-200 md:pl-6">
                  <p className="text-lg text-slate-700 leading-relaxed mb-2">
                    <span className="font-semibold text-emerald-800">VIREO, entreprise de rénovation</span> à
                    Paris et en Île-de-France : rénovation complète, intérieure, énergétique, façade et isolation.
                  </p>
                  <p className="text-sm text-slate-600 font-medium">
                    Artisan disposant d'une attestation officielle • Devis gratuit &amp; détaillé
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
